import React from 'react';
import { Box, Card, Text, Stack, Cluster, Icon } from '@iqueue/iq-ui';

/** Auth shell. Полноэкранное центрирование карточки ждёт примитива в iq-ui
    (docs/IQ_UI_CHAT_GAPS.md §10) — пока карточка рендерится в потоке. */
export default function AuthLayout({ title, children, footer }) {
  return (
    <Box padding={200}>
      <Card variant="outlined">
        <Card.Content>
          <Stack gap={200}>
            <Stack gap={50} align="center">
              <Cluster gap={100} align="center" wrap={false}>
                <Icon name="diamond" />
                <Text variant="headline-small" render={<span />}>BASEAGENT</Text>
              </Cluster>
              {title && <Text variant="body-medium" muted>{title}</Text>}
            </Stack>
            {children}
            {footer && (
              <Text variant="body-small" align="center">{footer}</Text>
            )}
          </Stack>
        </Card.Content>
      </Card>
    </Box>
  );
}
